import google from "../img/Google__G__logo.svg";
import facebook from "../img/facebook_logo.png";
import apple from "../img/apple_logo.png";
import Button from "react-bootstrap/Button";


function OtherAuth() {
  const apiUrl = process.env.REACT_APP_API_URL_SSO;
  
  return (
    <div className="kl-login-button-inscription">
      <Button
        onClick={() => window.location.href = apiUrl + "/connect/google"}
        variant="outline-secondary"
        size="lg"
        className="d-flex align-items-center justify-content-center"
      >
        <img
          src={google}
          alt="google logo"
          style={{ width: "20px", height: "20px" }}
        />
        <span className="flex-grow-1 text-center kl-button-span">
          Continuer avec Google
        </span>
      </Button>
      <Button
        onClick={() => window.location.href = apiUrl + "/connect/facebook"}
        variant="outline-secondary"
        size="lg"
        className="d-flex align-items-center justify-content-center"
      >
        <img
          src={facebook}
          alt="google logo"
          style={{ width: "20px", height: "20px" }}
        />
        <span className="flex-grow-1 text-center kl-button-span">
          Continuer avec Facebook
        </span>
      </Button>
      <Button
        variant="outline-secondary"
        size="lg"
        className="d-flex align-items-center justify-content-center "
      >
        <img
          src={apple}
          alt="google logo"
          style={{ width: "20px", height: "20px" }}
        />
        <span className="flex-grow-1 text-center kl-button-span">
          Continuer avec Apple
        </span>
      </Button>
    </div>
  );
}

export default OtherAuth;
